import {
	BottomWrapper,
	Container,
	GrayText,
	Line,
	ReportButton,
	ReportButtonContainer,
	SceneDescription,
	SceneName,
	TopTextSection,
	Wrapper,
} from './ConversationStartPlaceholder.styles';
import { Scene } from '../../types/Scene';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import InformationBlank from '@/common/images/daily/information-blank.svg';

type Props = { scene: Scene; onReport: () => void };

const ConversationStartPlaceholder = ({ scene, onReport }: Props) => {
	const langData = useLanguageData('features.sceneV3');

	return (
		<Wrapper>
			<Container>
				<TopTextSection>
					<SceneName>{scene.name}</SceneName>
					<SceneDescription>{langData.twoToFiveMin}</SceneDescription>
				</TopTextSection>
				<SceneDescription>{scene.description}</SceneDescription>
				<ReportButtonContainer>
					<ReportButton src={InformationBlank} onClick={onReport} />
				</ReportButtonContainer>
			</Container>

			<BottomWrapper>
				<Line />
				<GrayText>{langData.conversationStarted}</GrayText>
				<Line />
			</BottomWrapper>
		</Wrapper>
	);
};

export default ConversationStartPlaceholder;
